import { isEmpty } from "lodash"
import { PAGE_MODES } from "../constants/PAGE_MODE"

export const findModeByValue = (modeValue) => {
  return PAGE_MODES.find((mode) => mode.value === modeValue)
}

export const findModeLabel = (modeValue) => {
  
  const mode = PAGE_MODES.find((mode) => mode.value === modeValue)
  if(isEmpty(mode)) return

  return PAGE_MODES.find((mode) => mode.value === modeValue).label
}